export default __webpack_public_path__ + "static/media/earings.e6f631ca.png";